import { render, staticRenderFns } from "./AnnualReturnsStatus.vue?vue&type=template&id=0c349152&scoped=true&"
import script from "./AnnualReturnsStatus.vue?vue&type=script&lang=js&"
export * from "./AnnualReturnsStatus.vue?vue&type=script&lang=js&"
import style0 from "./AnnualReturnsStatus.vue?vue&type=style&index=0&id=0c349152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c349152",
  null
  
)

export default component.exports